export default {
  waiting: '平台将在您提交开店申请后 5 个工作日内完成审核。您也可以通过联系平台',
  qrCodeTipZh1: '招商微信客服',
  qrCodeTipZh2: '来咨询进展',
  txt: '查询入驻申请状态',
  continueCreateStore: '继续创建店铺',
  // from
  phone: '输入手机号查询入驻申请状态',
  code: '验证码',
  query: '查询',
  ruleMsgPhone: '请检查手机号',
  ruleMsgCode: '请输入验证码',
  // table
  date: '申请日期',
  name: '店铺名',
  type: '店铺类型',
  status: '状态',
  detail: '查看详情',
  check: '查看',
  TypeB: 'B类',
  TypeC: 'C类',
  pendingReview: '待审核',
  reviewPassed: '审核通过',
  reviewRefused: '审核拒绝',
  back: '上一步',
  goingBackUpdateInfo: '退回上一步，不会保留本步骤已填写或修改的信息。',
  stayOnThisStep: '不退回，留在本步骤',
  continueToPreviousStep: '继续退回上一步'
}
